
const Admin_Alias = "informed-decisions"

// Get user info from sessionStorage
export const getUserInfo = () => {
  if (typeof window === 'undefined') return null
  
  const userInfoStr = sessionStorage.getItem('user_info')
  if (!userInfoStr) return null
  
  try {
    return JSON.parse(userInfoStr)
  } catch (error) {
    console.error('Error parsing user info from sessionStorage:', error)
    return null
  }
}

// Clear user info from sessionStorage
export const clearUserInfo = () => {
  if (typeof window !== 'undefined') {
    sessionStorage.removeItem('user_info')
  }
}

export const setUserInfo = (userInfo) => {
  if (typeof window !== 'undefined') {
    sessionStorage.setItem('user_info', JSON.stringify(userInfo))
  }
}

/**
 * Get permissions for a specific alias from entity_grants
 * @param {string} alias - The alias to look up
 * @returns {Array<string>} Array of permissions for the alias, empty array if not found
 */
export const getPermissionsForAlias = (alias, userInfoArg) => {
  const userInfo = userInfoArg ?? getUserInfo()
  if (!userInfo || !userInfo.entity_grants) {
    return []
  }
  
  const grant = userInfo.entity_grants.find(g => g.alias === alias)
  return grant ? grant.permissions || [] : []
}

/**
 * Get all aliases the user has access to
 * @returns {Array<string>} Array of aliases, empty array if none
 */
export const getUserAliases = (userInfoArg) => {
  const userInfo = userInfoArg ?? getUserInfo()
  if (!userInfo || !userInfo.entity_grants) {
    return []
  }
  
  return userInfo.entity_grants.map(g => g.alias).filter(Boolean)
}

export const checkUserAlias = (alias, userInfoArg) => {
  const userInfo = userInfoArg ?? getUserInfo()
  if (!userInfo || !userInfo.entity_grants) {
    // No cached user or no entity_grants means we cannot prove access    
    return false
  }

  // Accept either the exact alias or the global admin alias (informed-decisions)
  const hasAccess = userInfo.entity_grants.find(
    (grant) => grant.alias === alias || grant.alias === Admin_Alias
  )

  const result = !!hasAccess;
   
  return result
}

/**
 * Check if user has a specific permission for an alias
 * @param {string} alias - The alias to check
 * @param {string} permission - The permission to check (e.g., 'viewer', 'admin')
 * @returns {boolean} True if user has the permission
 */
export const hasPermission = (alias, permission, userInfoArg) => {
  const permissions = getPermissionsForAlias(alias, userInfoArg)
  return permissions.includes(permission)
}